import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const generatePdfBlobFromRef = async (elementRef, options = {}) => {
    const { pageSize = 'a4', orientation = 'portrait' } = options;
  
    if (!elementRef?.current) {
      throw new Error('Element ref is not attached');
    }
  
    const canvas = await html2canvas(elementRef.current, {
      scale: 2, // better resolution
      useCORS: true, // handles images from other domains
    });
  
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation,
      unit: 'mm',
      format: pageSize,
    });
  
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
  
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * pageWidth) / canvas.width;
  
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
  
    // Return blob instead of saving
    return new Promise((resolve) => {
      const blob = pdf.output('blob');
      resolve(blob);
    });
  };